import { render, staticRenderFns } from "./PropertyPreview.vue?vue&type=template&id=51c37dc2&scoped=true"
import script from "./PropertyPreview.vue?vue&type=script&lang=js"
export * from "./PropertyPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c37dc2",
  null
  
)

export default component.exports